import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../models/user.model';
import { environment } from '../../../environments/environment';

export interface ListUsersParams {
  page?: number;
  per_page?: number;
  search?: string;
  sort_by?:
    | 'name'
    | 'company'
    | 'email'
    | 'type'
    | 'oportunities'
    | 'invitation_sent_at'
    | 'active';
  sort_direction?: 'asc' | 'desc';
}

export interface ListUsersResponse {
  data: User[];
  links: {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
  };
  meta: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

@Injectable({ providedIn: 'root' })
export class UsersService {
  private readonly http = inject(HttpClient);

  list(params?: ListUsersParams): Observable<ListUsersResponse> {
    return this.http.get<ListUsersResponse>(`${environment.apiUrl}/users`, {
      params: params as Record<string, string | number | boolean>,
    });
  }

  getById(id: string): Observable<{ data: User }> {
    return this.http.get<{ data: User }>(`${environment.apiUrl}/users/${id}`);
  }

  create(data: Partial<User>): Observable<{ data: User }> {
    return this.http.post<{ data: User }>(`${environment.apiUrl}/users`, data);
  }

  update(id: string, data: Partial<User>): Observable<{ data: User }> {
    return this.http.patch<{ data: User }>(`${environment.apiUrl}/users/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/users/${id}`);
  }

  updateStatus(id: string, active: boolean): Observable<{ data: User }> {
    return this.http.patch<{ data: User }>(`${environment.apiUrl}/users/${id}/status`, { active });
  }

  sendInvitation(id: string): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/users/${id}/invite`, {});
  }
}
